// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22kER","right":"Footer_right__2vZxx","buttons":"Footer_buttons__23L_-"};